import { faker } from '@faker-js/faker';
import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay, requireAuth } from '@/test/mocks/utils';

import { WaitlistStatusResponse, SessionErrorResponse } from './types';

export const getWaitlistStatus = (
  profile_id: string,
  variant_id: string
): Promise<WaitlistStatusResponse> => {
  return axios.get(
    `/user/v1/waitlist/status?profile_id=${profile_id}&variant_id=${variant_id}`
  );
};

export const getWaitlistStatusMockHandler = http.get(
  `${env.API_URL}/user/v1/waitlist/status`,
  async ({
    cookies,
    request,
  }): Promise<HttpResponse<WaitlistStatusResponse | SessionErrorResponse>> => {
    await networkDelay();
    const { error } = requireAuth(cookies);
    if (error) {
      return HttpResponse.json(
        {
          error: 'Internal server error',
          error_code: 'application-exception',
        },
        { status: 400 }
      );
    }

    const url = new URL(request.url);
    const variantId = url.searchParams.get('variant_id') ?? faker.string.uuid();

    const response: WaitlistStatusResponse = {
      status: 'success',
      waitlist_entries: [
        {
          waitlist_id: faker.string.uuid(),
          variant_id: variantId,
          product_id: faker.string.uuid(),
          status: 'ACTIVE',
          created_on: faker.date.past().getTime(),
          last_batch_check_on: faker.date.past().getTime(),
          expires_on: faker.date.future().getTime(),
          is_new_batch_available: false,
          // is_new_batch_available: true,
          // is_new_batch_available: faker.datatype.boolean(),
        },
      ],
      total_entries: 1,
    };

    return HttpResponse.json(response);
  }
);
